/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Text from "../ui/Text";
import FormatPrice from "../formatters/FormatPrice";

const TotalPriceInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TotalPriceGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const PriceBreakdown = ({ currency, subtotal, price, tip, deposit, discount, taxes, ...props }) => {
  return (
    <TotalPriceGroup {...props}>
      {!!subtotal && (
        <TotalPriceInfo>
          <Text>
            Subtotal
          </Text>
          <Text weight="bold">
            <FormatPrice value={subtotal} currency={currency} />
          </Text>
        </TotalPriceInfo>
      )}
      {!!tip && (
        <TotalPriceInfo>
          <Text>
            Tip
          </Text>
          <Text weight="bold">
            <FormatPrice value={tip.amount} currency={currency} />
          </Text>
        </TotalPriceInfo>
      )}
      {!!discount && (
        <TotalPriceInfo>
          <Text>
            Discount
          </Text>
          <Text weight="bold">
            <FormatPrice value={discount} currency={currency} />
          </Text>
        </TotalPriceInfo>
      )}
      {taxes &&
        taxes.length > 0 &&
        taxes.map((tax) => (
          <TotalPriceInfo key={tax.id}>
            <Text>
              {tax.name}
            </Text>
            <Text weight="bold">
              <FormatPrice value={tax.amount} currency={currency} />
            </Text>
          </TotalPriceInfo>
        ))}
      {!!deposit && (
        <TotalPriceInfo>
          <Text>
            Deposit
          </Text>
          <Text weight="bold">
            <FormatPrice value={deposit} currency={currency} />
          </Text>
        </TotalPriceInfo>
      )}

      {!!price && (
        <TotalPriceInfo>
          <Text color="dark">
            Total
          </Text>
          <Text color="dark" weight="bold">
            <FormatPrice value={price} currency={currency} />
          </Text>
        </TotalPriceInfo>
      )}
    </TotalPriceGroup>
  );
};

export default PriceBreakdown;
